export default __webpack_public_path__ + "static/media/head-desk-@2x.96a99823.jpg";